import React, { useState } from 'react';
import { InoButtonProps } from './InoButton.types';
import { MouseKeyboardEvent } from '../../types';
import { useMappedKeydown } from '../../hooks/useMappedKeydown';

export const InoButton: React.FC<InoButtonProps> = ({
  isActive = true,
  index,
  children,
  onClick,
  type = 'button',
  disabled = false,
  classNames = '',
  size = 'medium',
  variant = 'primary',
  onLeft,
  onRight,
  onUp,
  onDown,
  onBack,
  onFocus,
  onMouseEnter,
  ...rest
}) => {
  const [isActiveOnHover, setIsActiveOnHover] = useState(false);

  useMappedKeydown({
    isActive: isActive || isActiveOnHover,
    onOk: onClick,
    onBack: onBack,
    onLeft: onLeft,
    onRight: onRight,
    onUp: onUp,
    onDown: onDown,
    onMouseEnter: onMouseEnter,
    index,
  });

  return (
    <button
      type={type}
      onClick={(e) => {
        if (!disabled && onClick && (isActive || isActiveOnHover)) {
          onClick(e as MouseKeyboardEvent, index);
        }
      }}
      onMouseEnter={(e) => {
        setIsActiveOnHover(true);
        onMouseEnter && onMouseEnter(e as MouseKeyboardEvent, index);
      }}
      onMouseLeave={() => {
        setIsActiveOnHover(false);
      }}
      disabled={disabled}
      className={`ino-button ino-button--${variant} ino-button--${size} ${
        isActive || isActiveOnHover ? 'ino-button--active' : ''
      } ${classNames}`}
      {...rest}
    >
      {children}
    </button>
  );
};

export default InoButton;
